import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { UserPlus, Copy } from "lucide-react";
import { TmPagesPicker } from "@/components/company/TmPagesPicker";
import { TM_DEFAULT_PAGES } from "@/lib/tmPages";

export function InviteManagerDialog({ terminal, customerId, onClose }) {
  const [f, setF] = useState({ name: terminal.manager_name || "", email: terminal.manager_email || "" });
  const [pages, setPages] = useState(TM_DEFAULT_PAGES);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/invites", { ...f, pages, role: "terminal_manager", customer_id: customerId, terminal_id: terminal.id, origin_url: window.location.origin });
      setRes(data); toast.success(data.email_status?.sent === false ? "Invite created — copy the link below" : `Invite emailed to ${data.email}`);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={() => onClose(!!res)}>
      <DialogContent className="max-w-md" data-testid="invite-manager-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><UserPlus className="h-5 w-5 text-blue-700" />Invite terminal manager — {terminal.name}</DialogTitle></DialogHeader>
        {res ? (
          <div className="space-y-3 text-sm">
            <p>Portal access created for <b>{res.email}</b>. They'll only see drivers, units, filings, random selections and messages for <b>{terminal.name}</b>.</p>
            <div className="rounded-md border bg-slate-50 p-2 font-mono text-xs break-all" data-testid="invite-manager-link">{res.invite_link}</div>
            <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(res.invite_link); toast.success("Link copied"); }}><Copy className="h-4 w-4 mr-1" />Copy invite link</Button>
          </div>
        ) : (
          <form onSubmit={send} className="space-y-3">
            <div><Label>Manager name</Label><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="invite-manager-name" /></div>
            <div><Label>Email</Label><Input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="invite-manager-email" /></div>
            <TmPagesPicker value={pages} onChange={setPages} testid="invite-manager-pages" />
            <p className="text-xs text-slate-500">They'll receive an email with a link to set their password. Access is limited to this terminal's data; you can change their pages later under Users.</p>
            <DialogFooter><Button type="button" variant="outline" onClick={() => onClose(false)}>Cancel</Button><Button type="submit" disabled={busy} className="bg-blue-700 hover:bg-blue-800" data-testid="invite-manager-send">Send invite</Button></DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
